import {
  createEventObject,
  draggableFormItems,
  formInputInfo,
  postLink,
  registerObject,
} from "../types/types";
import ConsoleHelper from "../utils/logger";

const changeValue = (key: string, value: string) => {
  return {
    type: "CHANGEVALUE",
    payload: { key, value },
  };
};

const changeCreateState = (key: string, value: boolean) => {
  return {
    type: "CHANGECREATESTATE",
    payload: { key, value },
  };
};

const changeRegistrationInfo = (
  key: string,
  value: string,
  nestedKey: string
) => {
  return {
    type: "CHANGEREGISTRATIONINFO",
    payload: { nestedKey, key, value },
  };
};

const changePageStyling = (key: string, value: string, nestedKey: string) => {
  return {
    type: "CHANGEPAGESTYLING",
    payload: { nestedKey, key, value },
  };
};

const updateRegistrationInfo = (key: string, value: string) => {
  return {
    type: "UPDATEREGISTRATIONINFO",
    payload: { key, value },
  };
};

const changeRegistrationInfoDate = (key: string, value: Date) => {
  return {
    type: "CHANGEREGISTRATIONINFODATE",
    payload: { key, value },
  };
};

const setRegistrationQuestions = (value: draggableFormItems) => {
  return {
    type: "SETREGISTRATIONQUESTIONS",
    payload: value,
  };
};

const getEvent = (id: string) => {
  return { type: "START_EVENTSTATE_FETCH", payload: id };
};

const getAllEvents = (obj: { date: string; limit: string }) => {
  return { type: "START_EVENTS_FETCH", payload: obj };
};

const saveRegister = (data: registerObject) => {
  return { type: "START_REGISTRATION_SELECT_REQUEST", payload: data };
};

const startDraggableFormFetch = (form: string, language: string) => {
  return {
    type: "START_REGISTRATION_FORM_FETCH",
    payload: { form, language },
  };
};

const createEvent = (data: createEventObject) => {
  return {
    type: "START_EVENT_CREATE_REQUEST",
    payload: data,
  };
};

const startSaveRegistrationQuestions = (data: formInputInfo[]) => {
  return {
    type: "START_SAVE_REGISTRATION_QUESTIONS_REQUEST",
    payload: data,
  };
};

const startGetEventDetails = (id: string) => {
  return {
    type: "START_GET_EVENT_DETAILS_REQUEST",
    payload: id,
  };
};

const setEventDetails = (details: createEventObject, subEventId?: string) => {
  const payload = subEventId ? { details, subEventId } : { details };
  return {
    type: "SET_EVENT_DETAILS",
    payload: payload,
  };
};

const getEventDetails = (id: string, subEventId?: string) => {
  const payload = subEventId ? { id, subEventId } : { id };
  ConsoleHelper("here", payload);
  return {
    type: "GET_EVENT_DETAILS",
    payload: payload,
  };
};

const startPostLinkForm = (data: postLink) => {
  return {
    type: "START_POST_LINK_FORM",
    payload: data,
  };
};

const startGetLinkSuggestion = () => {
  return {
    type: "START_GET_LINK_SUGGESTION",
    payload: undefined,
  };
};

const getAllLyytiEvents = (locale: string) => {
  return {
    type: "START_LYYTIEVENTS_FETCH",
    payload: locale,
  };
};

const getLyytiParticipants = (event: string) => {
  return {
    type: "START_LYYTIPARTICIPANTS_FETCH",
    payload: event,
  };
};

const getSubEventDetails = (subEventId: string) => {
  return {
    type: "START_SUBEVENT_DETAILS_FETCH",
    payload: subEventId,
  };
};

const createSubEvent = (eventId: string) => {
  return {
    type: "START_CREATE_SUBEVENT_REQUEST",
    payload: eventId,
  };
};

const formActions = {
  getEvent,
  getAllEvents,
  saveRegister,
  createEvent,
  createSubEvent,
  startDraggableFormFetch,
  startSaveRegistrationQuestions,
  startGetLinkSuggestion,
  startPostLinkForm,
  changeValue,
  changeCreateState,
  changeRegistrationInfo,
  changePageStyling,
  changeRegistrationInfoDate,
  setRegistrationQuestions,
  startGetEventDetails,
  updateRegistrationInfo,
  setEventDetails,
  getEventDetails,
  getAllLyytiEvents,
  getLyytiParticipants,
  getSubEventDetails,
};

export default formActions;
